import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import useFullPageLoader from "common/UseFullPageLoader";
import { dashboardApi } from "services/dasboard";
import {
  dashboardIcon1,
  dashboardIcon2,
  dashboardIcon3,
  dashboardIcon4,
} from "assets/icons";
import DashboardTabs from "./section/DashboardTabs";
import MostUseCoupon from "./section/MostUseCoupon";
import LastUseCoupon from "./section/LeastUseCoupon";
import LeastUseCoupon from "./section/LeastUseCoupon";
import DeliveryAreas from "./section/DeliveryAreas";
import MostSellingCategory from "./section/MostSellingCategory";
import SalesDetails from "./section/SalesDetails";
import moment from "moment";
import { Link } from "react-router-dom";
// import TotalSurveysChart from "./TotalSurveysChart";
// import SurveyDistributionChart from "./SurveyDistributionChart";
// import SurveyCreatedList from "pages/user-management/SurveyCreatedList";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [loader, onShow, onHide] = useFullPageLoader();
  const [input, setInput] = useState({
    startDate: "",
    endDate: "",
  });
  // ------------dashboard-data---------------
  useEffect(() => {
    const fetchDashboard = async () => {
      onShow();
      try {
        // const query = {
        //   ...(input.startDate && { startDate: input.startDate }),
        //   ...(input.endDate && { endDate: input.endDate })
        // }
        const query = {
          ...(input.startDate && {
            startDate: moment(input.startDate).format("DD/MM/YYYY"),
          }),
          ...(input.endDate && {
            endDate: moment(input.endDate).format("DD/MM/YYYY"),
          }),
        };
        const res = await dashboardApi(query);
        const { code, data } = res?.data;
        if (code === 200) {
          setDashboardData(data || {});
        }
      } catch (error) {
        console.log(error);
      } finally {
        onHide();
      }
    };
    const isFirstLoad = !input.startDate && !input.endDate;
    const isBothDatesSelected = input.startDate && input.endDate;

    if (isFirstLoad || isBothDatesSelected) {
      fetchDashboard();
    }
  }, [input.startDate, input.endDate]);
  return (
    <>
      {loader}
      <div className="dashboard_home">
        <div className="page_title">
          <h3>Dashboard</h3>
        </div>
        {loader}
        {/* ------------Dashboard-Tabs-------------- */}
        <DashboardTabs dashboardData={dashboardData} onHide={onHide} />

        <div className="row g-4">
          {/* ------------Sales-Details---------------- */}
          <SalesDetails
            weeklySales={dashboardData?.weeklySales}
            input={input}
            setInput={setInput}
            onHide={onHide}
          />
          {/* ------Most-selling-Categories---------- */}
          <MostSellingCategory
            mostSellingCategories={dashboardData?.mostSellingCategories}
            onHide={onHide}
          />
        </div>

        {/* -------Top-5-Delivery-Areas---------- */}
        <DeliveryAreas
          deliveryAreas={dashboardData?.topDeliveryAreas}
          onHide={onHide}
        />

        {/* -------lasTop-2-Most-Used-Coupon-Codes----- */}
        <MostUseCoupon
          mostUsedCoupons={dashboardData?.mostUsedCoupons}
          onHide={onHide}
        />

        {/* ------Top-2-Least-Used-Coupon-Codes------ */}
        <LeastUseCoupon
          leastUsedCoupons={dashboardData?.leastUsedCoupons}
          onHide={onHide}
        />
      </div>
    </>
  );
};

export default Dashboard;
